module.exports = __webpack_public_path__ + "img/04711147000655.9842bfa9.png";